import { render, staticRenderFns } from "./ProjectAccess.vue?vue&type=template&id=49528a4e&"
import script from "./ProjectAccess.vue?vue&type=script&lang=js&"
export * from "./ProjectAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports